import Helpers from '../../../../common/helpers/Helpers';
import Constants from '../../../../common/constants/Constants';
import { TransferToBlob, DeleteFileFromBlob, FormatUploadFileName } from './CloudFileTransfer';

export const getLogList = (query) => {
  return Helpers.get(Constants.REPORTS_URL, {}, query);
};

export const createLog = (log) => {
  return Helpers.post(Constants.INSTRUMENT_LOGBOOK_URL, {}, log);
};

export const getBlobUrlWithSasTokenForUpload = (serialNumber, fileName) => {
  let query = {
    serialNumber: serialNumber,
    fileName: fileName,
  };

  return Helpers.get(`${Constants.FILE_TRANSFER_URL}/sasToken/fileUpload/logBook`, {}, query);
};

export const getBlobUrlWithSasTokenForDownload = (serialNumber, fileName) => {
  let query = {
    serialNumber: serialNumber,
    fileName: fileName,
  };

  return Helpers.get(`${Constants.FILE_TRANSFER_URL}/sasToken/fileDownload/logBook`, {}, query);
};

export const deleteFileFromBlob = (blobUrl) => {
  let query = {
    blobUrl: blobUrl,
  };

  return Helpers.delete(`${Constants.FILE_TRANSFER_URL}/`, {}, query);
};

export const transferAttachementToCloud = async (newLogBookLog, progressHandler, abortSignal) => {
  if (newLogBookLog.FileName.length > 0) {
    let CloudFile = `${newLogBookLog.LogBookId}/${FormatUploadFileName(newLogBookLog.FileName)}`;

    let blobLink = '';

    blobLink = await TransferToBlob(
      newLogBookLog.SerialNumber,
      newLogBookLog.FileInput.files[0],
      CloudFile,
      progressHandler,
      abortSignal
    );
    newLogBookLog.HasAttachement = true;
  }
  try {
    delete newLogBookLog.FileInput;
    await createLog(newLogBookLog);
  } catch (err) {
    if (newLogBookLog.HasAttachement) {
      await DeleteFileFromBlob(blobLink);
    }
    throw err;
  }
};
